<template>
    <Layout
        :header="{ text: titleText, backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="3"></Process>
        </div>
        <div class="pb-8">
            <h2 class="font-bold text-2xl">
                預約視訊驗證
            </h2>
            <p class="pt-2">本公司將發送視訊連結至以下留存之行動電話，若資訊不正確，請與您的服務人員聯繫或致電本公司 0809-000-550 辦理行動電話變更。</p>
        </div>
        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">
                發送簡訊之行動電話
            </h3>
            <ul>
                <li class="pb-2">
                    <h5 class="font-bold text-md pb-2">
                        要保人：{{ applicantName }}
                    </h5>
                    <input class="w-full" type="text" inputmode="tel" :disabled="disabledApplicantPhone"
                        v-model="applicantPhone" placeholder="請輸入行動電話">
                    <p class="text-[#C10013] pt-2">將以此電話完成OTP驗證及發送視訊連結簡訊</p>
                </li>
                <li v-for="(data, index) in insuredData" :key="index" class="mt-2">
                    <h5 class="font-bold text-md pb-2">
                        被保險人：{{ data.insdName }}
                    </h5>
                    <input class="w-full" type="text" inputmode="tel" :disabled="data.disabledInsuredPhone"
                        v-model="data.insuredMobile" placeholder="請輸入行動電話">
                    <p v-if="!data.disabledInsuredPhone" class="text-[#C10013] pt-2">同時變更您本次預約申請的保單之被保險人行動電話</p>
                </li>
            </ul>
        </div>
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="!isPass" @click="submit">下一步</button>
        </template>
        <Loading :is-loading="isLoading" />
        <InfoBox v-if="errorBoxVisble" :closeHandel="closeBox" title="系統提示" :buttonText="errorBoxButtonText">
            <div v-html="errorMessage" />
        </InfoBox>
    </Layout>
</template>
<script setup>
import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import Loading from '@/components/Loading.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue'
import aplCatlCode from '@/json/aplCatlCode';
import { ref, computed, reactive, } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getLoanContactInfo, postLoanSubmitContact } from '@/apis/CloudECounter';
import routeName from '@/router/constant';
import { maskMobile } from '@/utils/maskUtils.js';

const store = useStore();
const router = useRouter();
const isLoading = ref(false);

// 要保人電話
const applicantFullPhone = ref('');
const applicantPhone = ref('');
const applicantName = ref('');
const disabledApplicantPhone = ref(false);
// 被保險人資料
const insuredData = reactive([])
const storedData = ref({});
const errorBoxVisble = ref(false);
const errorMessage = ref('');
const errorType = ref('');
const titleText = ref('');

const errorBoxButtonText = reactive({
    yes: "確認",
})

const isPass = computed(() => {
    return applicantPhone.value && insuredData.every(el => Boolean(el.insuredMobile));
})


const aplCatl = computed(() => store.state.services.aplCatl);
if (aplCatl.value === aplCatlCode.BENEIFCIARY) {
    titleText.value = '受益人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_CHANGE) {
    titleText.value = '要保人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
    titleText.value = '要保人或被保險人姓名變更'
} else if (aplCatl.value === aplCatlCode.LOAN) {
    titleText.value = '保單借款'
}

const initData = async () => {
    isLoading.value = true;
    try {
        const resData = await getLoanContactInfo()
        storedData.value = resData.data;
        console.log(storedData.value.insdInfos);

        applicantName.value = resData.data?.applicantName;

        applicantFullPhone.value = resData.data?.mobile;
        applicantPhone.value = maskMobile(resData.data?.mobile);
        disabledApplicantPhone.value = resData.data?.mobile ? true : false;

        insuredData.splice(0);
        let invalidInsuredNames = [];
        for (let insdInfo of resData.data?.insdInfos) {
            if (insdInfo.insuredMobile && !/^09\d{8}$/.test(insdInfo.insuredMobile)) {
                // errorMessage.value = `被保險人 ${insdInfo.insdName} 的行動電話為國外電話，考量作業時效，本次無法使用雲端e櫃檯服務功能，請通知您的服務人員協助辦理，或洽詢免付費服務電 0809-000-550，造成您的不便，敬祈見諒！`;
                // errorBoxButtonText.yes = '我知道了';
                // errorBoxVisble.value = true;
                // errorType.value = 'STOP_PROCESS';
                // return;
                invalidInsuredNames.push(insdInfo.insdName);
            }
            insuredData.push({
                insuredMobile: maskMobile(insdInfo.insuredMobile),
                disabledInsuredPhone: insdInfo.insuredMobile ? true : false,
                insdName: insdInfo.insdName,
                insdId: insdInfo.insdId,
            });
        }
        if (!/^09\d{8}$/.test(resData.data?.mobile)) {
            errorMessage.value = '您的行動電話為國外電話，考量作業時效，本次無法使用雲端e櫃檯服務功能，請通知您的服務人員協助辦理，或洽詢免付費服務電話 0809-026-688，造成您的不便，敬祈見諒！';
            errorBoxButtonText.yes = '我知道了';
            errorBoxVisble.value = true;
            errorType.value = 'STOP_PROCESS';
            return;
        }

        if (invalidInsuredNames.length >= 1) {
            let names = invalidInsuredNames.join("、")
            errorMessage.value = `被保險人 ${names} 的行動電話為國外電話，考量作業時效，本次無法使用雲端e櫃檯服務功能，請通知您的服務人員協助辦理，或洽詢免付費服務電話 0809-026-688，造成您的不便，敬祈見諒！`;
            errorBoxButtonText.yes = '我知道了';
            errorBoxVisble.value = true;
            errorType.value = 'STOP_PROCESS';
            return;
        }
    } catch (e) { }
    finally {
        isLoading.value = false;
    }
}
initData();

const submit = () => {
    errorMessage.value = '';
    let mobile = disabledApplicantPhone.value ? storedData.value.mobile : applicantPhone.value;
    if (!/^09\d{8}$/.test(mobile)) {
        errorMessage.value = '您輸入的行動電話為外國門號，考量作業時效，請改輸入台灣門號，謝謝！'
        errorBoxVisble.value = true;
        return;
    }

    const insdInfos = [];
    for (let insdInfo of insuredData) {
        let insuredInfo = {};
        if (insdInfo.disabledInsuredPhone) {
            console.log(storedData.value.mobile);
            let orgData = storedData.value.insdInfos.find(el => el.insdId === insdInfo.insdId);
            insuredInfo = {
                insdId: orgData.insdId,
                insuredMobile: orgData.insuredMobile,
            }
        } else {
            insuredInfo = {
                insdId: insdInfo.insdId,
                insuredMobile: insdInfo.insuredMobile,
            }
        }

        if (!/^09\d{8}$/.test(insuredInfo.insuredMobile)) {
            errorMessage.value = `您輸入的被保險人 ${insdInfo.insdName} 行動電話為外國門號，考量作業時效，請改輸入台灣門號，謝謝！`
            errorBoxVisble.value = true;
            return;
        }

        if (aplCatl.value === aplCatlCode.LOAN && insuredData.length === 2) {
            if ((insuredData[0].insdId !== insuredData[1].insdId) && insuredData[0].insuredMobile === insuredData[1].insuredMobile) {
                errorMessage.value = `不同被保險人行動電話不可相同`
                errorBoxVisble.value = true;
                return;
            }
            if (applicantFullPhone.value === insuredData[0].insuredMobile || applicantFullPhone.value === insuredData[1].insuredMobile) {
                errorMessage.value = `要保人與被保險人行動電話不可相同`
                errorBoxVisble.value = true;
                return;
            }
        }

        insdInfos.push(insuredInfo);
    }

    goNextPage({ mobileCountry: "", email: "", mobile, insdInfos, })
}

const goNextPage = async (data) => {
    isLoading.value = true;
    try {
        const result = await postLoanSubmitContact(data)
        console.log(result);
        router.push({ name: routeName.CLOUD_E_COUNTER_PERIOD });
    } catch (e) { } finally {
        isLoading.value = false;
    }
}

const closeBox = () => {
    if (errorType.value === 'STOP_PROCESS') {
        router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
    }
    errorBoxVisble.value = false;
}

</script>
<style lang="scss" scoped></style>
